import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Features } from '../types/features';

@Injectable({
  providedIn: 'root',
})
export class FeatureListService {
  private _aptitudeFeatureList$ = new ReplaySubject<Features>(1);
  private _adminFeatureList$ = new ReplaySubject<Features>(1);

  aptitudeFeatureList$ = this._aptitudeFeatureList$.asObservable();
  adminFeatureList$ = this._adminFeatureList$.asObservable();

  constructor() {}

  setAptitudeFeatureList(featureList: Features) {
    this._aptitudeFeatureList$.next(featureList);
  }

  setAdminFeatureList(featureList: Features) {
    this._adminFeatureList$.next(featureList);
  }
}
